module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"rack":"Rack","notify email":"Send email","email":"Email","notify mobile":"Send SMS","mobile":"Mobile","all":"All","save":"Save","delete":"Delete"},"de":{"rack":"Rack","notify email":"Sende Email","email":"Email","notify mobile":"Sende SMS","mobile":"Mobil Nummer","all":"Alle","save":"Speichern","delete":"Löschen"}}')
  delete Component.options._Ctor
}
